export var MARKETING_JOURNEY = 'SIGNUP';
export var MARKETING_CHANNEL = 'WEB';
export var BRANDCODES = ['PINN'];